import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden w-full">
      <Header />
      <main className="flex-1 pt-20 overflow-x-hidden w-full max-w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
